import { FunctionComponent } from 'react';

/** Simplified national-flag watermarks for the circular language selector, shared by the SRP
 * header (DesktopFilterCategories) and the generic site-wide navbar (LanguageSelector) so both
 * render identically instead of keeping their own copies. */
export const FlagFI: FunctionComponent = () => (
  <svg viewBox="0 0 24 24" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" aria-hidden="true">
    <rect width="24" height="24" fill="white" />
    <rect x="9" width="3" height="24" fill="#003580" />
    <rect y="10" width="24" height="3" fill="#003580" />
  </svg>
);

/** Flag of the Swedish-speaking Finns (Finland-Swedes), not the Swedish national flag: our "sv"
 * locale is Finland Swedish, and Finland-Swedes are Finnish citizens, not Swedish nationals. */
export const FlagSV: FunctionComponent = () => (
  <svg viewBox="0 0 24 24" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" aria-hidden="true">
    <rect width="24" height="24" fill="#C8102E" />
    <rect x="9" width="3" height="24" fill="#FECC00" />
    <rect y="10" width="24" height="3" fill="#FECC00" />
  </svg>
);

export const FlagEN: FunctionComponent = () => (
  <svg viewBox="0 0 24 24" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" aria-hidden="true">
    <rect width="24" height="24" fill="#012169" />
    <polygon points="0,0 4,0 24,20 24,24 20,24 0,4" fill="white" />
    <polygon points="24,0 20,0 0,20 0,24 4,24 24,4" fill="white" />
    <polygon points="0,0 2,0 24,22 24,24 22,24 0,2" fill="#C8102E" />
    <polygon points="24,0 22,0 0,22 0,24 2,24 24,2" fill="#C8102E" />
    <rect x="9" width="6" height="24" fill="white" />
    <rect y="9" width="24" height="6" fill="white" />
    <rect x="10.5" width="3" height="24" fill="#C8102E" />
    <rect y="10.5" width="24" height="3" fill="#C8102E" />
  </svg>
);

export const LANG_FLAGS: Record<'fi' | 'sv' | 'en', FunctionComponent> = { fi: FlagFI, sv: FlagSV, en: FlagEN };
